const mutations = {
  setStatistics(state, payload) {
    state.stats = payload;
  },
};

export default mutations;
